import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<{ id: number, name: string, status: string, updatedUTC: number }, unknown>[] = [
		buildColumn(util, 'Id', row => row.id),
		buildColumn(util, 'Status', row => row.status),
		buildColumn(util, 'Text', row => row.name, { header: 'Name' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated', hidden: true }),
	];


	return columns;

}